import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { Campaign, Targeting } from '@feathr/blackbox';
import type { ListResponse } from '@feathr/rachis';

import DisplayReachEstimate from './AdWizardAudienceStep.DisplayReachEstimate';
import type { IUseEstimatedReach } from './AdWizardAudienceStep.EstimatedReach.hooks';
import MetaReachEstimate from './AdWizardAudienceStep.MetaReachEstimate';

import * as styles from './AdWizardAudienceStep.css';

interface IEstimatedReachProps {
  campaign: Campaign;
  targetings: ListResponse<Targeting>;
  /** The shared per-channel reach forecast, computed once at the wizard level. */
  reach: IUseEstimatedReach;
}

function EstimatedReach({
  campaign,
  targetings,
  reach,
}: Readonly<IEstimatedReachProps>): JSX.Element {
  const { displayReach, metaReach, isLoading, showDisplay, showMeta } = reach;

  return (
    <>
      {showDisplay && (
        <div className={styles.estimatedReach}>
          <DisplayReachEstimate
            campaign={campaign}
            displayReach={displayReach}
            isLoading={isLoading}
            targetings={targetings}
          />
        </div>
      )}
      {showMeta && (
        <div className={styles.estimatedReach}>
          <MetaReachEstimate isLoading={isLoading} metaReach={metaReach} />
        </div>
      )}
    </>
  );
}

export default observer(EstimatedReach);
